import isEqual from 'lodash/isEqual';
import * as React from 'react';
import type { InfoBannerBlockViewModel } from '~/Blocks/InfoBannerBlock/InfoBannerBlockViewModel.csharp';
import { InfoBanner } from '~/Partials/InfoBanner/InfoBanner';
import { useVariableWithStableRef } from '~/Utils/Hooks/useVariableWithStableRef';

export interface InfoBannerWithStateProps {
    info: InfoBannerBlockViewModel | null;
    localStorageKey: string;
    onOpened: () => void;
    onClosed: () => void;
    closeTranslation: string;
}

export const InfoBannerWithState: React.FC<InfoBannerWithStateProps> = props => {
    const { localStorageKey, info, onOpened, onClosed, closeTranslation } = props;

    const [isBannerVisible, setIsBannerVisible] = React.useState(false);
    const onOpenedRef = useVariableWithStableRef(onOpened);

    React.useEffect(() => {
        if (!info?.infoText) {
            return;
        }

        const closedInfoBanner = localStorage.getItem(localStorageKey);

        if (closedInfoBanner) {
            const parsedInfoBanner = JSON.parse(closedInfoBanner);
            const areEqual = isEqual(parsedInfoBanner, info);

            if (areEqual) {
                return;
            }
        }

        setIsBannerVisible(true);
        onOpenedRef.current?.();
    }, [info, localStorageKey, onOpenedRef]);

    const closeInfoBanner = () => {
        setIsBannerVisible(false);
        onClosed();
        localStorage.setItem(localStorageKey, JSON.stringify(info));
    };

    return info && isBannerVisible ? (
        <InfoBanner model={info} closeInfoBanner={closeInfoBanner} closeTranslation={closeTranslation} />
    ) : null;
};
